import { InventoryItemTable as Table } from './components/InventoryItemTable';
import { InventoryItem } from '../inventory-items/inventoryItem';
import { InventoryItemFilter } from '../inventory-items/inventoryItemFilter';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { CreateButton, TableActions, getLoginData } from '@ami/react/core';
import { InventoryItemFilterComponent as FilterComponent } from './components/InventoryItemFilterComponent';
import { pagination } from '@ami/react/core';
import { appConfig } from '@ami/react/core';
import { getGenericData, saveGenericData } from '@ami/react/core';
import { isAmiUserAuthorizedToManageInventory } from '../authorization/amiPermissions';
import { Button } from '@ami/react/core';
import { downloadWithFallback } from '@ami/react/core';

const filterStorageKey = 'inventory-items-list-filters';

class InventoryItemListPage extends Component {
  constructor() {
    super();
    this.search = this.search.bind(this);
    this.handleBottomScroll = this.handleBottomScroll.bind(this);
    this.handleExport = this.handleExport.bind(this);
  }

  static propTypes = {
    history: PropTypes.object.isRequired,
    title: PropTypes.string,
  };

  state = {
    items: [],
    filter: null,
    loading: true,
    hasLoadedAllPages: false,
    page: 0,
    exporting: false,
  };

  async componentDidMount() {
    await this.initializeFilter();
    this.search();
  }

  async initializeFilter() {
    const saved = getGenericData(filterStorageKey);

    const filter = saved
      ? new InventoryItemFilter(saved)
      : new InventoryItemFilter();

    if (appConfig.isDealerApp && !filter.make) {
      const loginData = getLoginData();
      if (
        loginData &&
        loginData.userData &&
        loginData.userData.dealerSettings &&
        loginData.userData.dealerSettings.preferredMake &&
        loginData.userData.dealerSettings.preferredMake !== null
      ) {
        filter.make = loginData.userData.dealerSettings.preferredMake;
      }
    }

    this.setState({ filter });
  }

  search() {
    if (!appConfig.isCustomerApp) {
      saveGenericData(filterStorageKey, this.state.filter);
    }
    this.loadPage(0);
  }

  handleBottomScroll() {
    if (!this.state.hasLoadedAllPages) {
      this.loadPage(this.state.page + 1);
    }
  }

  loadPage(page) {
    if (!this.state.loading) {
      this.setState({ loading: true, page });
    }
    InventoryItem.search(this.state.filter, page, appConfig.isCustomerApp)
      .then((items) =>
        this.setState({
          items: page === 0 ? items : this.state.items.concat(items),
          hasLoadedAllPages: items.length < pagination.pageSize,
        })
      )
      .catch(() => {})
      .finally(() => this.setState({ loading: false }));
  }

  handleOnOpenEdit = (inventoryItemId) => {
    if (!inventoryItemId) {
      throw Error('Cannot edit Inventory Item. Invalid id specified.');
    }

    const urlSegment = appConfig.isManagementApp ? 'edit' : 'view';

    this.props.history.push(
      `/inventory-items/${urlSegment}/${inventoryItemId}`
    );
  };

  async handleExport() {
    const { filter } = this.state;
    this.setState({ exporting: true });
    InventoryItem.getForExport(filter)
      .then((exportModel) => {
        downloadWithFallback(exportModel, 'inventoryItems.csv');
      })
      .finally(() => this.setState({ exporting: false }));
  }

  render() {
    const { exporting } = this.state;
    return (
      <div>
        <div className="flextable">
          <h3 className="flextable-item flextable-primary page-title">
            {this.props.title}
          </h3>
          <div className="flextable-item">
            {appConfig.isManagementApp && (
              <Button
                key="1"
                label={exporting ? 'Exporting' : 'Export CSV'}
                onClick={this.handleExport}
                className="btn-primary me-2"
                showSpinner={exporting}
                disabled={exporting}
                iconName="download"
              />
            )}
            {appConfig.isManagementApp &&
              isAmiUserAuthorizedToManageInventory() && (
                <CreateButton
                  onCreate={() =>
                    this.props.history.push('/inventory-items/new')
                  }
                />
              )}
          </div>
        </div>
        <TableActions>
          <FilterComponent
            filter={this.state.filter}
            onChange={(x) =>
              this.setState({ filter: new InventoryItemFilter(x) })
            }
            onFilter={() => this.search()}
          />
        </TableActions>
        <Table
          onBottomScroll={this.handleBottomScroll}
          inventoryItems={this.state.items}
          onOpenEdit={this.handleOnOpenEdit}
          loading={this.state.loading}
        />
      </div>
    );
  }
}

const InventoryItemList = withRouter(InventoryItemListPage);
export { InventoryItemList };
